module.exports = __webpack_public_path__ + "static/cv-curriculum-fc783eead5ed6ba4a536371d33f6b6ce.png";